export default {
  namespaced: true,
  state: {
    answerStatus: false,
    correctStatus: false,
    currentExercise: 0,
    currentLives: 3,
    exerciseCompleted: false,
    explanationStatus: false,
    gameCompleted: false,
    homeScreenStatus: true,
    instructionsStatus: false,
    maxLives: 3,
    muteStatus: false,
    playerScore: 0,
    settingsStatus: false,
    speechStatus: true,
  },
  getters: {
    answerStatus: state => state.answerStatus,
    correctStatus: state => state.correctStatus,
    currentExercise: state => state.currentExercise,
    currentLives: state => state.currentLives,
    exerciseCompleted: state => state.exerciseCompleted,
    explanationStatus: state => state.explanationStatus,
    gameCompleted: state => state.gameCompleted,
    homeScreenStatus: state => state.homeScreenStatus,
    instructionsStatus: state => state.instructionsStatus,
    maxLives: state => state.maxLives,
    muteStatus: state => state.muteStatus,
    playerScore: state => state.playerScore,
    settingsStatus: state => state.settingsStatus,
    speechStatus: state => state.speechStatus,
  },
  mutations: {
    homeClickStart(state) {
      state.homeScreenStatus = false;
      state.instructionsStatus = true;
    },
    resetGame(state) {
      state.currentExercise = 0;
      state.currentLives = 3;
      state.exerciseCompleted = false;
      state.explanationStatus = false;
      state.gameCompleted = false;
      state.homeScreenStatus = true;
      state.instructionsStatus = false;
      state.maxLives = 3;
      state.muteStatus = false;
      state.playerScore = 0;
    },
  },
  actions: {
    homeClickStart({ commit }) {
      commit('homeClickStart');
    },
    resetGame({ commit }) {
      commit('resetGame');
    },
  },
};
